import { render, staticRenderFns } from "./NoteBox.vue?vue&type=template&id=71365486&"
import script from "./NoteBox.vue?vue&type=script&lang=js&"
export * from "./NoteBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports